import { useMemo } from 'preact/hooks';
import { LineItem } from '@pperform/pp-data-mappers';
import { usePTPConfigContext } from 'GlobalConfig.context';
import { useDetectDevice } from 'hooks/useDetectDevice';
import { LineItemsListWrapper } from './LineItems.styles';
import { Slider } from '../Slider';
import { ListView } from '../ListView';

interface LineItemsProps {
  lineItems: LineItem[];
}

const LineItems = ({ lineItems }: LineItemsProps): JSX.Element => {
  const { lineItem: lineItemConfig } = usePTPConfigContext();
  const { isMobile } = useDetectDevice();

  const allCardsData = useMemo(
    () =>
      lineItems?.map((lineItem: LineItem, index: number) => ({
        id: `pp_carousel_item_${index}`,
        data: lineItem,
      })),
    [lineItems],
  );

  if (!Array.isArray(lineItems) || !lineItems.length) {
    return null;
  }

  const isTileView = lineItemConfig?.visualisationType === 'tile_view';
  const isPaddingTop = allCardsData.length < 3 || !isTileView || isMobile;

  return (
    <LineItemsListWrapper isPaddingTop={isPaddingTop}>
      {isTileView ? (
        <Slider cards={allCardsData} />
      ) : (
        <ListView cards={allCardsData} />
      )}
    </LineItemsListWrapper>
  );
};

export { LineItems };
